import React, { useState } from "react";
import { SignIn } from "./api/Authentication";

function useAppSelector() {
  const [user, setUser] = useState("");

  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSignIn = async (
    event: React.KeyboardEvent<any> | React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    if (loading) return;

    if (userPassword.length < 6) {
      setLoading(false);
      return setErrorMessage("Password must be at least 6 characters");
    }

    if (!userEmail || !userPassword) {
      setLoading(false);
      return setErrorMessage("Enter Username and Password");
    }

    setLoading(true);

    try {
      const userFound = await SignIn(userEmail.toLowerCase(), userPassword);

      if (!userFound) {
        setUser("");
        setErrorMessage("User not found");
      } else {
        setUser(userFound.id);
        setErrorMessage("");
      }

      if (userFound.error) {
        setErrorMessage(
          "Issue with Sign in attempt, Check User Name and Password."
        );
      }
    } catch (err) {
      setErrorMessage("Issue with Sign in attempt");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAuthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    if (name === "email") {
      setUserEmail(value);
    } else if (name === "password") {
      setUserPassword(value);
    }
  };

  return {
    handleAuthChange,
    handleSignIn,
    errorMessage,
    user,
    setUser,
    loading,
    userEmail,
    userPassword,
  };
}

export default useAppSelector;
